<app-header-modal [color]="'secondary-2'" title="{{title}}">
  <div icon *ngIf="showPalletDetails">
    <i class="uil uil-arrow-left" (click)="goBackToMap()"></i>
  </div>
  <div class="status-header" status *ngIf="showPalletDetails">
    <i class="uil uil-times" (click)="close()"></i>
  </div>
</app-header-modal>
<app-pigeonhole-modal *ngIf="showPositionDetails"
  [packages]="packages"
  [pigeonholeDetails]="pigeonholeDetails"
  [data]="data"
  (changeToPallet)="onChangeToPallet($event)"
  (closeModal)="close()">
</app-pigeonhole-modal>
<app-map-pallet-details *ngIf="showPalletDetails"
  [data]="palletDetails"
  (closeModal)="close()">
</app-map-pallet-details>